var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fieldList && _vm.fieldList.length > 0
    ? _c(
        "el-row",
        { staticStyle: {}, attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                {
                  class: _vm.noBorder && "no-border",
                  attrs: { shadow: _vm.shadow || "never" }
                },
                [
                  _vm.formTitle
                    ? _c("div", { staticClass: "panel-title" }, [
                        _vm._v(_vm._s(_vm.$t(_vm.formTitle)))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  [
                    _c(
                      "el-form",
                      {
                        ref: "pageform",
                        attrs: {
                          model: _vm.data,
                          rules: _vm.rules,
                          size: "mini",
                          "label-width": "100px"
                        }
                      },
                      [
                        _vm._l(_vm.getConfigList(), function(item, index) {
                          return _c(
                            "el-col",
                            {
                              key: index,
                              attrs: {
                                xs: item.xs || 12,
                                sm: item.sm || 12,
                                md: item.md || 12,
                                lg: item.lg || 12,
                                xl: item.xl || 12
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: item.value,
                                    label: _vm.$t(item.label),
                                    required: item.required
                                  }
                                },
                                [
                                  item.type === "select"
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            "label-width": item.labelWidth,
                                            disabled: item.disabled,
                                            clearable:
                                              item.clearable === false
                                                ? item.clearable
                                                : true,
                                            filterable: item.filterable,
                                            placeholder: _vm.getPlaceholder(
                                              item
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.handleEvent(
                                                item.event,
                                                _vm.data[item.value]
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.data[item.value],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                item.value,
                                                $$v
                                              )
                                            },
                                            expression: "data[item.value]"
                                          }
                                        },
                                        _vm._l(
                                          _vm.listTypeInfo[item.list],
                                          function(childItem, childIndex) {
                                            return _c("el-option", {
                                              key: childIndex,
                                              attrs: {
                                                label: childItem.key,
                                                value: childItem.value
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : item.type === "number"
                                    ? _c("el-input-number", {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          placeholder: _vm.getPlaceholder(item),
                                          disabled: item.disabled,
                                          min: item.min || 0,
                                          max: item.max,
                                          precision: item.precision || 0,
                                          "controls-position": "right"
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "input"
                                    ? _c("el-input", {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          placeholder: _vm.getPlaceholder(item),
                                          disabled: item.disabled,
                                          readonly: item.readonly
                                        },
                                        on: {
                                          change: function(e) {
                                            return _vm.handleEvent(
                                              item.event,
                                              e
                                            )
                                          }
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.handleEvent(
                                              item.event,
                                              null
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "password"
                                    ? _c("el-input", {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          placeholder: _vm.getPlaceholder(item),
                                          disabled: item.disabled,
                                          type: "password"
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "textarea"
                                    ? _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.getPlaceholder(item),
                                          disabled: item.disabled,
                                          type: "textarea"
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "radio"
                                    ? [
                                        _c(
                                          "el-radio-group",
                                          {
                                            on: {
                                              change: function(value) {
                                                return _vm.handleEvent(
                                                  item.event,
                                                  value
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.data[item.value],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.data,
                                                  item.value,
                                                  $$v
                                                )
                                              },
                                              expression: "data[item.value]"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  label: item.yes || "Y",
                                                  disabled: item.disabled,
                                                  placeholder:
                                                    _vm.$t(item.yesLabel) ||
                                                    _vm.getPlaceholder(item)
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.yesLabel ||
                                                      _vm.$t("table.yes")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  label: item.no || "N",
                                                  disabled: item.disabled,
                                                  placeholder:
                                                    _vm.$t(item.noLabel) ||
                                                    _vm.getPlaceholder(item)
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.noLabel ||
                                                      _vm.$t("table.no")
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : item.type === "picker"
                                    ? [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 11 } },
                                          [
                                            _c("el-time-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.getPlaceholder(
                                                  item
                                                ),
                                                disabled: item.disabled,
                                                format: "HH:mm",
                                                "value-format": "HH:mm"
                                              },
                                              model: {
                                                value:
                                                  _vm.data[
                                                    item.startTime.value
                                                  ],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.data,
                                                    item.startTime.value,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data[item.startTime.value]"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.startTime && item.endTime
                                          ? _c(
                                              "el-col",
                                              {
                                                staticClass: "line text-center",
                                                attrs: { span: 1 }
                                              },
                                              [_vm._v("-")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 11 } },
                                          [
                                            _c("el-time-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.getPlaceholder(
                                                  item
                                                ),
                                                disabled: item.disabled,
                                                format: "HH:mm",
                                                "value-format": "HH:mm"
                                              },
                                              model: {
                                                value:
                                                  _vm.data[item.endTime.value],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.data,
                                                    item.endTime.value,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data[item.endTime.value]"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    : item.type === "daterange"
                                    ? _c("el-date-picker", {
                                        attrs: {
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                          type: "daterange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": _vm.$t("date.to"),
                                          "start-placeholder": _vm.$t(
                                            "date.startDate"
                                          ),
                                          "end-placeholder": _vm.$t(
                                            "date.endDate"
                                          ),
                                          "picker-options": item.options
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "daterangeTime"
                                    ? _c("el-date-picker", {
                                        attrs: {
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                          format: "yyyy-MM-dd HH:mm",
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": _vm.$t("date.to"),
                                          "start-placeholder": _vm.$t(
                                            "date.startDate"
                                          ),
                                          "end-placeholder": _vm.$t(
                                            "date.endDate"
                                          ),
                                          "picker-options": item.options
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "date"
                                    ? _c("el-date-picker", {
                                        attrs: {
                                          "value-format": "yyyy-MM-dd",
                                          align: "right",
                                          placeholder: _vm.getPlaceholder(item),
                                          "picker-options": item.options,
                                          format: item.format || "yyyy-MM-dd",
                                          disabled: item.disabled
                                        },
                                        on: {
                                          change: function(e) {
                                            return _vm.handleEvent(
                                              item.event,
                                              e
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : item.type === "dateHourTime"
                                    ? [
                                        _c("el-date-picker", {
                                          attrs: {
                                            "value-format": "yyyy-MM-dd HH:mm",
                                            type: "datetime",
                                            align: "right",
                                            "default-value": new Date(),
                                            "picker-options": _vm.pickerOptions
                                          },
                                          model: {
                                            value: _vm.data[item.value],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                item.value,
                                                $$v
                                              )
                                            },
                                            expression: "data[item.value]"
                                          }
                                        })
                                      ]
                                    : item.type === "dateMintuinesTime"
                                    ? [
                                        _c("el-date-picker", {
                                          attrs: {
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            type: "datetime",
                                            disabled: item.disabled,
                                            align: "right",
                                            "default-value": new Date(),
                                            "picker-options": _vm.pickerOptions
                                          },
                                          model: {
                                            value: _vm.data[item.value],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                item.value,
                                                $$v
                                              )
                                            },
                                            expression: "data[item.value]"
                                          }
                                        })
                                      ]
                                    : item.type === "dateTime"
                                    ? [
                                        item.date
                                          ? _c(
                                              "el-col",
                                              { attrs: { span: 11 } },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    type: "date",
                                                    placeholder: _vm.getPlaceholder(
                                                      item
                                                    ),
                                                    disabled: item.disabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.data[item.date.value],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.data,
                                                        item.date.value,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "data[item.date.value]"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : item.startTime
                                          ? _c(
                                              "el-col",
                                              { attrs: { span: 11 } },
                                              [
                                                _c("el-time-picker", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: _vm.getPlaceholder(
                                                      item
                                                    ),
                                                    disabled: item.disabled,
                                                    format: "HH:mm",
                                                    "value-format": "HH:mm"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.data[
                                                        item.startTime.value
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.data,
                                                        item.startTime.value,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "data[item.startTime.value]"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (item.date || item.startTime) &&
                                        item.time
                                          ? _c(
                                              "el-col",
                                              {
                                                staticClass: "line text-center",
                                                attrs: { span: 1 }
                                              },
                                              [_vm._v("-")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.time
                                          ? _c(
                                              "el-col",
                                              { attrs: { span: 11 } },
                                              [
                                                item.time.type === "timeSelect"
                                                  ? _c("el-time-select", {
                                                      attrs: {
                                                        disabled: item.disabled,
                                                        "picker-options": {
                                                          start: "00:30",
                                                          step: "00:30",
                                                          end: "24:00"
                                                        },
                                                        placeholder: _vm.getPlaceholder(
                                                          item
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.data[
                                                            item.time.value
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.data,
                                                            item.time.value,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "data[item.time.value]"
                                                      }
                                                    })
                                                  : _c("el-time-picker", {
                                                      staticStyle: {
                                                        width: "100%"
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.getPlaceholder(
                                                          item
                                                        ),
                                                        disabled: item.disabled,
                                                        format: "HH:mm",
                                                        "value-format": "HH:mm"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.data[
                                                            item.time.value
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.data,
                                                            item.time.value,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "data[item.time.value]"
                                                      }
                                                    })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    : item.type === "address"
                                    ? _c(
                                        "div",
                                        { staticClass: "item-inline" },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 18 } },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: item.disabled,
                                                  placeholder: "地址"
                                                },
                                                model: {
                                                  value: _vm.data[item.value],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.data,
                                                      item.value,
                                                      $$v
                                                    )
                                                  },
                                                  expression: "data[item.value]"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 4 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    disabled: item.disabled
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleClick(
                                                        item.event
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("获取经纬度")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : item.type === "cities"
                                    ? _c("el-cascader", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          props: { value: "label" },
                                          options: _vm.citiesOP,
                                          filterable: "",
                                          disabled: item.disabled
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 } },
                          [_vm._t("default")],
                          2
                        )
                      ],
                      2
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e22af06e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e22af06e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog-form.vue
// module id = null
// module chunks = 